import { render, staticRenderFns } from "./CourseWare.vue?vue&type=template&id=59c11f1c&scoped=true&"
import script from "./CourseWare.vue?vue&type=script&lang=js&"
export * from "./CourseWare.vue?vue&type=script&lang=js&"
import style0 from "./CourseWare.vue?vue&type=style&index=0&id=59c11f1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c11f1c",
  null
  
)

export default component.exports